import { call, put, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import { getRankingRewardsSuccess, getRankingRewardsFailed, GET_RANKING_REWARDS_START } from '~/views/app/redux/actions/pools';

const getRankingRewardsApi = (props) => {
  return api.get('/admin/pools/stats', props);
};

function* doGetRankingRewards(action) {
  try {
    const response = yield call(getRankingRewardsApi, action.payload);
    yield put(getRankingRewardsSuccess(response));
    if (action.onSuccess) {
      yield action.onSuccess(response);
    }
  } catch (error) {
    yield put(getRankingRewardsFailed());
    if (action.onError) {
      yield action.onError(error);
    }
  }
}

export default function* watchGetRankingRewards() {
  yield takeLatest(GET_RANKING_REWARDS_START, doGetRankingRewards);
}